import { createFileRoute } from '@tanstack/react-router'
import { LaporanTable } from '../../../../components/LaporanTable'

export const Route = createFileRoute('/platform/desa/$desaId/laporan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <LaporanTable desaId={desaId} />
  },
})
